import { ApolloProvider } from "@apollo/client";
import { AppProps } from "next/app";
import "normalize.css";
import "../../postcssVariables.css";
import "../global.css";
import { useApollo } from "../graphql/client";
import { GoogleTagManagerProvider } from "../providers/GoogleTagManager/GoogleTagManagerProvider";

export default function App({
  Component,
  pageProps,
}: AppProps<{ initialApolloState: Record<string, unknown> | undefined }>) {
  const apolloClient = useApollo(pageProps.initialApolloState);

  return (
    <ApolloProvider client={apolloClient}>
      <GoogleTagManagerProvider />
      <Component {...pageProps} />
    </ApolloProvider>
  );
}
